<script lang="ts">
</script>

<div class="zinput-group">
    <slot></slot>
</div>
